import { createContext, useContext } from "react";

import type { FormFieldContextValue, FormFieldControlProps } from "./types-form-field";

export const FormFieldContext = createContext<FormFieldContextValue | null>(null);

export function useFormFieldContext(): FormFieldContextValue {
  const context = useContext(FormFieldContext);
  if (!context) throw new Error("FormField.* deve ser usado dentro de FormField.Root");
  return context;
}

/** Props do controle (`id`, `name`, `aria-*`, `disabled`) para quem prefere render-prop em vez de `FormField.Control`. */
export function useFormFieldControlProps(): FormFieldControlProps {
  return useFormFieldContext().controlProps;
}
